export const SET_PROVIDERS         = 'SET_PROVIDERS';
export const SET_SELECTED_PROVIDER = 'SET_SELECTED_PROVIDER';
